import { useMemo } from 'react';

import { usePreferredPhysicalAdressStore } from '../PersonalInformation/PreferredPhysicalAddress/stores';

const SPECIAL_WARNING_STATES_CODES = [
  'AZ',
  'CA',
  'ID',
  'LA',
  'NV',
  'NM',
  'TX',
  'WA',
  'WI',
];

const useHasWarningAddressState = () => {
  const physicalState = usePreferredPhysicalAdressStore((state) => state.state.physicalState);
  const hasWarningState = useMemo(() => {
    return SPECIAL_WARNING_STATES_CODES.some((code) => code === physicalState);
  }, [physicalState]);

  return hasWarningState;
};

export default useHasWarningAddressState;
